import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsForYouRoute: InvariantJiraRoute = {
	name: 'assets-for-you',
	path: '/jira/assets/for-you',
	exact: true,
};
